import React from 'react';

const NotificationBanner = ({ message, ...props }) => <div className="notificationBanner" { ...props }>{ message }</div>;

export default NotificationBanner;
